import React from 'react';
import {observer} from 'mobx-react';
import {StandingsWidgetProps} from "../../models/standings-widget.props";
import {GameBadgeProps} from "../../../../core/components/game-badge/game-badge";
import {LiveScoreBadge} from "../../../../core/components/live-score-badge/live-score-badge";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {StandingsWidgetRowViewModel} from "../../models/standings-widget.row-view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";

export class StandingsWidgetLiveScoreBadgeProps extends StandingsWidgetProps {
  controller: StandingsWidgetController;
  row: StandingsWidgetRowViewModel;
}

export const StandingsWidgetLiveScoreBadge = observer(({
                                                         controller,
                                                         liveGame
                                                       }: StandingsWidgetLiveScoreBadgeProps) => {
  const {state} = controller;
  const {currentLinkModel, isLive} = state;
  const score: String = liveGame ? `${liveGame?.domainModel?.homeCompetitor.score} - ${liveGame?.domainModel?.awayCompetitor.score}` : '';

  const gameClick = () => controller.action(ACTION_TYPES.matchDetailsClick, {
    gameId: liveGame.id,
    competitionId: liveGame.domainModel.competition.id,
    status: liveGame.domainModel.statusGroup,
    source: APP.ANALYTICS.SOURCES[currentLinkModel.name],
    placement: APP.GOOGLE_ANALYTICS.SOURCES[currentLinkModel.name],
    currentLinkModelName: currentLinkModel.name,
    screenId: currentLinkModel.params.id,
    sportTypeId: liveGame.domainModel.sport.id
  })

  const onMouseEnter = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows, {hoveredCompetitorIds: [liveGame?.domainModel?.homeCompetitor.id, liveGame?.domainModel?.awayCompetitor.id]});
  const onMouseLeave = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows, {hoveredCompetitorIds: []});

  const gameBadgeProps: GameBadgeProps = {
    className: classNames(styles.live_game_bubble),
    tooltipLabel: liveGame?.tooltipLabel,
    winnerStatus: liveGame?.winnerStatus,
    link: liveGame?.linkModel,
    onMouseEnter,
    onMouseLeave,
    onClick: () => gameClick(),routeProps: {
      dataSource: {
        game: {
          apiModel: liveGame?.domainModel.apiModel,
          homeCompetitor: liveGame?.domainModel.homeCompetitor,
          awayCompetitor: liveGame?.domainModel.awayCompetitor,
          sport: liveGame?.domainModel.sport,
          competition: liveGame?.domainModel.competition,
          startTime: liveGame?.domainModel.startTime,
        }
      }
    }
  }

  return isLive ? <LiveScoreBadge {...gameBadgeProps}>{score}</LiveScoreBadge> : null
});

